export default __webpack_public_path__ + "static/media/clipartWoman.85ec1522.png";